'use client';

import { Trans } from '@lingui/macro';
import { Container, Stack, Typography } from '@mui/material';
import { Button, Center } from '@prismo-io/design-system';
import type { FC } from 'react';

type Props = {
  reset: () => void;
};

export const UserNotFoundScreen: FC<Props> = (props) => {
  const { reset } = props;

  return (
    <Center>
      <Container maxWidth="sm">
        <Stack spacing={5} alignItems="center">
          <Typography variant="h1" textAlign="center">
            <Trans>Utilisateur inconnu</Trans>
          </Typography>
          <Stack spacing={3}>
            <Typography variant="h2" textAlign="center">
              <Trans>
                Nous sommes désolés, mais le profil que vous essayez d'afficher
                n'existe&nbsp;pas.
              </Trans>
            </Typography>
          </Stack>
          <Button onClick={() => reset()} variant="contained" color="gradient">
            <Trans>Retourner à l'accueil</Trans>
          </Button>
        </Stack>
      </Container>
    </Center>
  );
};
